import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { getProfileQueryKey } from 'features/users';
import { updateNotificationsSettings } from '../../services';

type NotificationSettings = {
  badgeNotificationsSettings: {
    enableNotifications: boolean;
  };
  emailNotificationsSettings: {
    enableNotifications: boolean;
    events: boolean;
    giving: boolean;
    newsfeed: boolean;
    program: boolean;
  };
  pushNotificationsSettings: {
    enableNotifications: boolean;
    events: boolean;
    giving: boolean;
    messaging: boolean;
    newsfeed: boolean;
    program: boolean;
  };
};

export const useUpdateNotificationsSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { notifications: NotificationSettings; userId: string }>({
    async mutationFn({ notifications, userId }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      await updateNotificationsSettings({
        notifications: {
          badge_notifications_settings: {
            enable_notifications: notifications.badgeNotificationsSettings.enableNotifications,
          },
          email_notifications_settings: {
            enable_notifications: notifications.emailNotificationsSettings.enableNotifications,
            events: notifications.emailNotificationsSettings.events,
            giving: notifications.emailNotificationsSettings.giving,
            newsfeed: notifications.emailNotificationsSettings.newsfeed,
            program: notifications.emailNotificationsSettings.program,
          },
          push_notifications_settings: {
            enable_notifications: notifications.pushNotificationsSettings.enableNotifications,
            events: notifications.pushNotificationsSettings.events,
            giving: notifications.pushNotificationsSettings.giving,
            messaging: notifications.pushNotificationsSettings.messaging,
            newsfeed: notifications.pushNotificationsSettings.newsfeed,
            program: notifications.pushNotificationsSettings.program,
          },
        },
        userId,
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
    },
    async onSuccess() {
      // TODO: save user to cache from response, dont need to refetch
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
